import * as React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { RouteComponentProps } from 'react-router';
import { OurRoute } from "./OurRoute";

export default class RoutePortal extends OurRoute {


    constructor(props, context) {
        super(props, context);
        this.namesMatch = this.namesMatch.bind(this);
    }

    namesMatch(currentHost, serverDataHost) {
        currentHost = currentHost.toLowerCase().replace("-east2").replace("-central");
        serverDataHost = serverDataHost.toLowerCase().replace("-east2").replace("-central");
        return currentHost === serverDataHost;
    }

    render() {
        //
        //console.info(`RoutePortal match? '${this.props.computedMatch}'`);
        if (this.props.computedMatch) {
            //debugger;
            if (typeof window === 'undefined') {
                //console.info(`RoutePortal window undefined`);
                return super.render();
            }
            else {
                const serverData = window.serverData.data;  // we can assume the window object here because we won't 

                if (!window.location.host.toLowerCase().startsWith("localhost") && !this.namesMatch(window.location.host, serverData.appDomain)) {
                    //console.info(`RoutePortal not localhost and host '${window.location.host}' does not match domain '${serverData.appDomain}'`);
                    //debugger;
                    window.persistor.flush();
                    //window.setTimeout(() => {
                        window.location.host = serverData.appDomain;
                    //}, 100);
                    //debugger;
                    return "";
                }
                else {
                    //console.info(`RoutePortal super.render()`);
                    return super.render();
                }
            }
        }
        else {
            return "";
        }
    }

}

